import {
  CREATE_BRANCH,
  CREATE_BRANCH_SUCCESS,
  CREATE_BRANCH_FAIL,
  GET_BRANCHES,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_FAIL,
  UPDATE_BRANCH,
  UPDATE_BRANCH_SUCCESS,
  UPDATE_BRANCH_FAIL,
  DELETE_BRANCH,
  DELETE_BRANCH_SUCCESS,
  DELETE_BRANCH_FAIL,
  SELECT_BRANCH,
} from "./actionTypes"

export const selectedBranch = branchId => ({
  type: SELECT_BRANCH,
  payload: branchId,
})

export const getBranches = (page, limit, searchText, stateId, districtId) => ({
  type: GET_BRANCHES,
  payload: { page, limit, searchText, stateId, districtId },
})

export const getBranchesSuccess = branches => ({
  type: GET_BRANCHES_SUCCESS,
  payload: branches,
})

export const getBranchesFail = error => ({
  type: GET_BRANCHES_FAIL,
  payload: error,
})

export const createBranch = (branch, onCloseClick) => ({
  type: CREATE_BRANCH,
  payload: { branch, onCloseClick },
})

export const createBranchSuccess = branch => ({
  type: CREATE_BRANCH_SUCCESS,
  payload: branch,
})

export const createBranchFail = error => ({
  type: CREATE_BRANCH_FAIL,
  payload: error,
})

export const updateBranch = (branch, branchId, onCloseClick) => ({
  type: UPDATE_BRANCH,
  payload: { branch, branchId, onCloseClick },
})

export const updateBranchSuccess = branch => ({
  type: UPDATE_BRANCH_SUCCESS,
  payload: branch,
})

export const updateBranchFail = error => ({
  type: UPDATE_BRANCH_FAIL,
  payload: error,
})

export const deleteBranch = branchId => ({
  type: DELETE_BRANCH,
  payload: { branchId },
})

export const deleteBranchSuccess = branch => ({
  type: DELETE_BRANCH_SUCCESS,
  payload: branch,
})

export const deleteBranchFail = error => ({
  type: DELETE_BRANCH_FAIL,
  payload: error,
})
